export default __webpack_public_path__ + "static/media/team-photo-2016.f4f507e8.jpg";